const MenuItems = {
    AdminSchoolAdmin: [
        {
            title: "Dashboard",
            activeClass: "dashboard",
            // icon: "ti-dashboard",
            icon: "fas fa-tachometer-alt font-18 icon-side-bar",
            url: '/ad-sas-school',
            permission: "ALL_REPORT",
            isShow: false,
            children: []
        },
        {
            title: "Quản lý tài khoản",
            activeClass: "profile",
            // icon: "flaticon-group",
            icon: "fas fa-user font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-thong-tin-ca-nhan',
            permission: "ACCOUNT_EDIT_PROFILE",
            isShow: false
        },
        {
            title: "Quản lý thông báo",
            activeClass: "noti-management",
            icon: "fas fa-solid fa-bell font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-thong-bao',
            // permission: "ACCOUNT_EDIT_PROFILE",
            permission: "SCHOOL_LIST",
            isShow: false,
        },
        {
            title: "Quản lý tin tức",
            activeClass: "news-management",
            icon: "fas fa-solid fa-bell font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-tin-tuc',
            // permission: "ACCOUNT_EDIT_PROFILE",
            permission: "SCHOOL_LIST",
            isShow: false,
        },
        {
            title: "Quản lý phụ huynh",
            activeClass: "phu-huynh-management",
            icon: "fas fa-user-secret font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-phu-huynh',
            permission: "SCHOOL_LIST",
            isShow: false,
        },
        {
            title: "Hệ thống",
            activeClass: "system-school-management",
            icon: "fas fa-school font-18 icon-side-bar",
            permission: "SCHOOL_LIST|YEAR_LIST|GROUP_USER_LIST|USER_LIST",
            isShow: false,
            children: [
                {
                    title: "Quản lý trường học",
                    activeClass: "list-school-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-truong-hoc',
                    permission: "SCHOOL_EDIT",
                    isShow: false,
                },
                {
                    title: "Khai báo dữ liệu",
                    activeClass: "declaration-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/khai-bao-du-lieu',
                    permission: "YEAR_LIST|DEPARTMENT_LIST",
                    isShow: false,
                },
                {
                    title: "Kết chuyển dữ liệu",
                    activeClass: "transfer-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/ket-chuyen-du-lieu',
                    // permission: "YEAR_LIST|DEPARTMENT_LIST",
                    permission: "SCHOOL_LIST",
                    isShow: false,
                },
                {
                    title: "Quản lý nhóm người dùng",
                    activeClass: "group-user-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nhom-nguoi-dung',
                    permission: "GROUP_USER_LIST",
                    isShow: false,
                },
                {
                    title: "Quản lý người dùng",
                    activeClass: "user-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nguoi-dung',
                    permission: "USER_LIST",
                    isShow: false,
                },
                // {
                //     title: "Lịch sử người dùng",
                //     activeClass: "user-management",
                //     parentClass: "system-school-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/quan-ly-nguoi-dung',
                //     permission: "USER_LIST",
                //     isShow: false,
                // }
            ]
        },
        {
            title: "Quản lý tuyển sinh ",
            activeClass: "admissions-management",
            icon: "fas fa-user-plus font-18 icon-side-bar",
            permission: "QLTS_CUSTOMER_LIST|QLTS_CAMPAIGN_LIST|QLTS_CUSTOMER_GROUP_LIST",
            isShow: false,
            children: [
                {
                    title: "Quản lý nhóm khách hàng",
                    activeClass: "admissions-group-user",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/quan-ly-nhom-khach-hang',
                    permission: "QLTS_CUSTOMER_GROUP_LIST",
                    isShow: false,
                },
                {
                    title: "Chiến dịch tuyển sinh",
                    activeClass: "enrollment-campaign",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/chien-dich-tuyen-sinh',
                    permission: "QLTS_CAMPAIGN_LIST",
                    isShow: false,
                },
                {
                    title: "Danh sách khách hàng",
                    activeClass: "list-customer-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/danh-sach-khach-hang',
                    permission: "QLTS_CUSTOMER_LIST",
                    isShow: false,
                },
                {
                    title: "Báo cáo",
                    activeClass: "report-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/bao-cao',
                    permission: "QLTS_CUSTOMER_REPORT",
                    isShow: false,
                },
            ]
        },
        {
            title: "Quản lý học sinh",
            activeClass: "student-management",
            icon: "fas fa-graduation-cap font-18 icon-side-bar",
            permission: "SCHOOL_LIST",
            isShow: false,
            children: [
                {
                    title: "Hồ sơ học sinh",
                    activeClass: "student-info-management",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thong-tin-hoc-sinh',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Điểm danh",
                    activeClass: "attendance",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Phân lớp học sinh đầu cấp",
                    activeClass: "accept-first-year",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/phan-lop-hoc-sinh-dau-cap',
                    permission: "SCHOOL_LIST",
                },
            ]
        },
        {
            title: "Quản lý cán bộ ",
            activeClass: "staff-management",
            // icon: "flaticon-profile",
            icon: "fas fa-user-tie font-18",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Quản lý cán bộ",
                    activeClass: "list-staff",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-can-bo',
                    permission: "SCHOOL_LIST",
                },
                // {
                //     title: "Phân công chủ nhiệm",
                //     activeClass: "company-organizational-chart",
                //     parentClass: "staff-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/phan-cong-chu-nhiem',
                //     permission: "SCHOOL_LIST",
                // },
                // {
                //     title: "Làm thay chủ nhiệm",
                //     activeClass: "company-organizational-chart",
                //     parentClass: "staff-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/lam-thay-chu-nhiem',
                //     permission: "SCHOOL_LIST",
                // },
            ]
        },
        {
            title: "Quản lý chi phí ",
            activeClass: "wallet-management",
            icon: "fas fa-wallet font-18 icon-side-bar",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Cấu hình ưu đãi tuyển sinh khu vực",
                    activeClass: "admissions-zone",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-khu-vuc',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Cấu hình ưu đãi tuyển sinh ngày đăng ký",
                    activeClass: "admissions-register",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-ngay-dang-ky',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Cấu hình ưu đãi đặc biệt",
                    activeClass: "admissions-special",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-dac-biet',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Cấu hình các khoản phí",
                    activeClass: "fee-item",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-cac-khoan-phi',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Cấu hình giá học phí",
                    activeClass: "fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-hoc-phi',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Quản lý học phí",
                    activeClass: "list-fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-hoc-phi-hoc-sinh',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Quản lý thu phí",
                    activeClass: "list-invoice",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-cac-khoan-thu',
                    permission: "SCHOOL_LIST",
                },
            ]
        },
        {
            title: "Quản lý xe bus ",
            activeClass: "bus-management",
            icon: "fas fa-bus font-18 icon-side-bar",
            isShow: false,
            permission: "USER_LIST",
            children: [
                {
                    title: "Loại dịch vụ xe bus",
                    activeClass: "price-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-loai-tuyen-xe-bus',
                    permission: "ACCOUNT_EDIT_PROFILE",
                },
                {
                    title: "Tuyến xe bus",
                    activeClass: "list-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-tuyen-xe-bus',
                    permission: "ACCOUNT_EDIT_PROFILE",
                },
                {
                    title: "Đăng ký xe bus",
                    activeClass: "register-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dang-ky-xe-bus',
                    permission: "ACCOUNT_EDIT_PROFILE",
                },
                {
                    title: "Báo cáo điểm danh",
                    activeClass: "report-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-xe-bus',
                    permission: "ACCOUNT_EDIT_PROFILE",
                },
            ]
        },
        {
            title: "Quản lý CLB",
            activeClass: "clb-management",
            icon: "fas fa-users font-18 icon-side-bar",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Quản lý lớp CLB",
                    activeClass: "class-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-lop-clb',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Quản lý đăng ký CLB",
                    activeClass: "register-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-clb',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Điểm danh CLB",
                    activeClass: "attendance-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-clb',
                    permission: "SCHOOL_LIST",
                }
            ]
        },
        {
            title: "Quản lý dịch vụ khác",
            activeClass: "service-management",
            icon: "fas fa-clipboard font-18 icon-side-bar",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Quản lý sản phẩm",
                    activeClass: "list-service-product",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-san-pham-dich-vu',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Quản lý dịch vụ",
                    activeClass: "list-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dich-vu-khac',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Quản lý đăng ký dịch vụ",
                    activeClass: "register-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-dich-vu',
                    permission: "SCHOOL_LIST",
                }
            ]
        },

        {
            title: "Quản lý đón muộn",
            activeClass: "late-pick-up-management",
            icon: "fas fa-clock font-18 icon-side-bar",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Cấu hình giá đón muộn",
                    activeClass: "config-late",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-don-muon',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Điểm danh đón hàng ngày",
                    activeClass: "late-pick-up",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-don-muon',
                    permission: "SCHOOL_LIST",
                },
                // {
                //     title: "Quản lý thanh toán đón muộn",
                //     activeClass: "payment-pick-late-up",
                //     parentClass: "late-pick-up-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/quan-ly-thanh-toan-don-muon',
                //     permission: "SCHOOL_LIST",
                // }
            ]
        },

        {
            title: "Quản lý dinh dưỡng",
            activeClass: "menu-management",
            // icon: "flaticon-profile",
            icon: "fas fa-mortar-pestle font-18",
            isShow: false,
            permission: "SCHOOL_LIST",
            children: [
                {
                    title: "Loại thực phẩm",
                    activeClass: "food-type",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/loai-thuc-pham',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Nhóm thực phẩm",
                    activeClass: "food-group",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nhom-thuc-pham',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Nhà cung cấp",
                    activeClass: "supplier",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nha-cung-cap',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Thực phầm",
                    activeClass: "food",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-pham',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Món ăn",
                    activeClass: "food-eat",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-mon-an',
                    permission: "SCHOOL_LIST",
                },
                // {
                //     title: "Dịch vụ khác",
                //     activeClass: "service-other",
                //     parentClass: "menu-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/dich-vu-khac',
                //     permission: "SCHOOL_LIST",
                // },
                // {
                //     title: "Nhóm ăn",
                //     activeClass: "group-eat",
                //     parentClass: "menu-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/quan-ly-nhom-an',
                //     permission: "SCHOOL_LIST",
                // },
                {
                    title: "Thực đơn",
                    activeClass: "menu",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-don',
                    permission: "SCHOOL_LIST",
                },
                {
                    title: "Thực đơn tuần",
                    activeClass: "menu-week",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/thuc-don-tuan',
                    permission: "SCHOOL_LIST",
                },
                // {
                //     title: "Đăng ký ăn",
                //     activeClass: "payment-eat",
                //     parentClass: "menu-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/dang-ky-an',
                //     permission: "SCHOOL_LIST",
                // },
                // {
                //     title: "Thanh toán ăn",
                //     activeClass: "payment-eat",
                //     parentClass: "menu-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/thanh-toan-an',
                //     permission: "SCHOOL_LIST",
                // },
            ]
        },
        {
            title: "Quản lý cơ sở vật chất ",
            activeClass: "permission-management",
            icon: "fas fa-user-shield font-18 icon-side-bar",
            url: '/ad-sas-school/permission-management',
            isShow: false,
            permission: "",
        },
        {
            title: "Báo cáo ",
            activeClass: "permission-management",
            icon: "fas fa-user-shield font-18 icon-side-bar",
            url: '/ad-sas-school/permission-management',
            isShow: false,
            permission: "",
        },
        {
            title: "Quản lý LOG ",
            activeClass: "log-management",
            icon: "fas fa-history font-18 icon-side-bar",
            isShow: false,
            url: '/ad-sas-school/log-management',
            permission: "SCHOOL_LIST",
        },
    ],
    AdminSchool: [
        {
            title: "Dashboard",
            activeClass: "dashboard",
            // icon: "ti-dashboard",
            icon: "fas fa-tachometer-alt font-18 icon-side-bar",
            url: '/ad-sas-school',
            permission: "ALL_REPORT",
            isShow: false,
            children: []
        },
        {
            title: "Quản lý tài khoản",
            activeClass: "profile",
            // icon: "flaticon-group",
            icon: "fas fa-user font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-thong-tin-ca-nhan',
            permission: "ACCOUNT_EDIT_PROFILE",
            isShow: false
        },
        {
            title: "Hệ thống",
            activeClass: "system-school-management",
            icon: "fas fa-school font-18 icon-side-bar",
            permission: "SCHOOL_LIST|YEAR_LIST|GROUP_USER_LIST|USER_LIST",
            isShow: false,
            children: [
                {
                    title: "Thông tin nhà trường",
                    activeClass: "list-school-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/sua-truong-hoc',
                    permission: "SCHOOL_EDIT",
                    isShow: false,
                },
                {
                    title: "Khai báo dữ liệu",
                    activeClass: "declaration-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/khai-bao-du-lieu',
                    permission: "YEAR_LIST|DEPARTMENT_LIST",
                    isShow: false,
                },
                {
                    title: "Quản lý nhóm người dùng",
                    activeClass: "group-user-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nhom-nguoi-dung',
                    permission: "GROUP_USER_LIST",
                    isShow: false,
                },
                {
                    title: "Quản lý người dùng",
                    activeClass: "user-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nguoi-dung',
                    permission: "USER_LIST",
                    isShow: false,
                },
                // {
                //     title: "Lịch sử người dùng",
                //     activeClass: "user-management",
                //     parentClass: "system-school-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/quan-ly-nguoi-dung',
                //     permission: "USER_LIST",
                //     isShow: false,
                // }
            ]
        },
        {
            title: "Quản lý tuyển sinh ",
            activeClass: "admissions-management",
            icon: "fas fa-user-plus font-18 icon-side-bar",
            permission: "QLTS_CUSTOMER_LIST|QLTS_CAMPAIGN_LIST|QLTS_CUSTOMER_GROUP_LIST",
            isShow: false,
            children: [
                {
                    title: "Quản lý nhóm khách hàng",
                    activeClass: "admissions-group-user",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/quan-ly-nhom-khach-hang',
                    permission: "QLTS_CUSTOMER_GROUP_LIST",
                    isShow: false,
                },
                {
                    title: "Chiến dịch tuyển sinh",
                    activeClass: "enrollment-campaign",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/chien-dich-tuyen-sinh',
                    permission: "QLTS_CAMPAIGN_LIST",
                    isShow: false,
                },
                {
                    title: "Danh sách khách hàng",
                    activeClass: "list-customer-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/danh-sach-khach-hang',
                    permission: "QLTS_CUSTOMER_LIST",
                    isShow: false,
                },
                {
                    title: "Báo cáo",
                    activeClass: "report-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/admissions/bao-cao',
                    permission: "QLTS_CUSTOMER_REPORT",
                    isShow: false,
                },
            ]
        },
    ]
};

export default MenuItems